export default "__VITE_ASSET__CdocqGSW__"